import React, { useCallback, useMemo, useState } from 'react'
import PropTypes from 'prop-types'
import { QUERY_KEYS } from '../../../../../api/queryKeys'
import WealthboxNoteRow from '../shared/WealthboxNoteRow'
import WealthboxNoteDetailModal from '../shared/WealthboxNoteDetailModal'
import CreateWealthboxNoteModal from '../shared/CreateWealthboxNoteModal'

const NOTE_INVALIDATE_KEYS = [
  [QUERY_KEYS.wealthboxDomainQuery, 'list-preset']
]

function WealthboxNotesContent ({ items, limit, config, contactId, createOpen, onCloseCreate }) {
  const [selectedNote, setSelectedNote] = useState(null)

  const enableEdit = config?.enableEdit ?? false
  const previewLength = config?.previewLength ?? 200
  const scope = config?.scope || 'client'

  // Sort by created_at desc (most recent first), then cap at `limit`. We
  // asked the server for `limit * 2` so the cap is informed by actual
  // ordering. The list-preset hook also passes `order=updated` to Wealthbox
  // so we get a useful sort server-side too.
  const sorted = useMemo(() => {
    const arr = Array.isArray(items) ? [...items] : []
    arr.sort((a, b) => {
      const da = a.created_at ? new Date(a.created_at).getTime() : 0
      const db = b.created_at ? new Date(b.created_at).getTime() : 0
      return db - da
    })
    return arr.slice(0, limit)
  }, [items, limit])

  const handleRowClick = useCallback((note) => setSelectedNote(note), [])
  const handleCloseDetail = useCallback(() => setSelectedNote(null), [])

  // IMPORTANT: do NOT early-return on empty state - the create modal must stay
  // mounted so the parent's Create button (which only toggles `createOpen`)
  // can actually open it. See WealthboxEventsContent for the same rationale.
  return (
    <>
      {sorted.length
        ? (
          <div>
            {sorted.map(note => (
              <WealthboxNoteRow
                key={note.id}
                note={note}
                previewLength={previewLength}
                onClick={() => handleRowClick(note)}
              />
            ))}
          </div>
        )
        : (
          <div className='p-md font-size-sm' style={{ color: 'var(--text-color-subtle)' }}>
            No notes match the current filters.
          </div>
        )}

      <WealthboxNoteDetailModal
        open={!!selectedNote}
        onClose={handleCloseDetail}
        note={selectedNote}
        enableEdit={enableEdit}
        invalidateQueryKeys={NOTE_INVALIDATE_KEYS}
      />

      <CreateWealthboxNoteModal
        open={createOpen}
        onClose={onCloseCreate}
        scope={scope}
        contactId={contactId}
        invalidateQueryKeys={NOTE_INVALIDATE_KEYS}
      />
    </>
  )
}

WealthboxNotesContent.propTypes = {
  items: PropTypes.array,
  limit: PropTypes.number,
  config: PropTypes.object,
  contactId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  createOpen: PropTypes.bool,
  onCloseCreate: PropTypes.func
}

export default WealthboxNotesContent
